//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IV2Client {
    /**
     * @return No Content
     */
    deleteReport(reportId: string): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteReports(body?: string[] | undefined): Promise<BatchDeleteResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    exportReport(body?: ExportReportRequest | undefined): Promise<ExportResultDto>;
    /**
     * @return Success
     */
    getEmptyReportDto(): Promise<TestReportDto>;
    /**
     * @return Success
     */
    getExportDownloadStatus(id: string): Promise<ExportResultDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    startReportDownload(body?: ExportReportRequest | undefined): Promise<ExportResultDto>;
    /**
     * @param model (optional) 
     * @param paginationToken (optional) 
     * @param limit (optional) 
     * @param fullReport (optional) 
     * @return Success
     */
    listItemReportHistory(model?: string | undefined, paginationToken?: string | undefined, limit?: number | undefined, fullReport?: boolean | undefined): Promise<ListItemReportHistoryResult>;
    /**
     * @param model (optional) 
     * @param paginationToken (optional) 
     * @param limit (optional) 
     * @param fullReport (optional) 
     * @return Success
     */
    listReportHistory(model?: string | undefined, paginationToken?: string | undefined, limit?: number | undefined, fullReport?: boolean | undefined): Promise<ListReportHistoryResult>;
}

export class V2Client implements IV2Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return No Content
     */
    deleteReport(reportId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReport(_response);
        });
    }

    protected processDeleteReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteReports(body?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<BatchDeleteResponse> {
        let url_ = this.baseUrl + "/api/v2/report/batchdelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReports(_response);
        });
    }

    protected processDeleteReports(response: AxiosResponse): Promise<BatchDeleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchDeleteResponse.fromJS(resultData200);
            return Promise.resolve<BatchDeleteResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchDeleteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportReport(body?: ExportReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ExportResultDto> {
        let url_ = this.baseUrl + "/api/v2/report/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportReport(_response);
        });
    }

    protected processExportReport(response: AxiosResponse): Promise<ExportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportResultDto.fromJS(resultData200);
            return Promise.resolve<ExportResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmptyReportDto(  cancelToken?: CancelToken | undefined): Promise<TestReportDto> {
        let url_ = this.baseUrl + "/api/v2/report/emptydto";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmptyReportDto(_response);
        });
    }

    protected processGetEmptyReportDto(response: AxiosResponse): Promise<TestReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestReportDto.fromJS(resultData200);
            return Promise.resolve<TestReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestReportDto>(null as any);
    }

    /**
     * @return Success
     */
    getExportDownloadStatus(id: string , cancelToken?: CancelToken | undefined): Promise<ExportResultDto> {
        let url_ = this.baseUrl + "/api/v2/report/export/status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportDownloadStatus(_response);
        });
    }

    protected processGetExportDownloadStatus(response: AxiosResponse): Promise<ExportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportResultDto.fromJS(resultData200);
            return Promise.resolve<ExportResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startReportDownload(body?: ExportReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ExportResultDto> {
        let url_ = this.baseUrl + "/api/v2/report/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartReportDownload(_response);
        });
    }

    protected processStartReportDownload(response: AxiosResponse): Promise<ExportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportResultDto.fromJS(resultData200);
            return Promise.resolve<ExportResultDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResultDto>(null as any);
    }

    /**
     * @param model (optional) 
     * @param paginationToken (optional) 
     * @param limit (optional) 
     * @param fullReport (optional) 
     * @return Success
     */
    listItemReportHistory(model?: string | undefined, paginationToken?: string | undefined, limit?: number | undefined, fullReport?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<ListItemReportHistoryResult> {
        let url_ = this.baseUrl + "/api/v2/report/history?";
        if (model === null)
            throw new Error("The parameter 'model' cannot be null.");
        else if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (paginationToken === null)
            throw new Error("The parameter 'paginationToken' cannot be null.");
        else if (paginationToken !== undefined)
            url_ += "paginationToken=" + encodeURIComponent("" + paginationToken) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (fullReport === null)
            throw new Error("The parameter 'fullReport' cannot be null.");
        else if (fullReport !== undefined)
            url_ += "fullReport=" + encodeURIComponent("" + fullReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListItemReportHistory(_response);
        });
    }

    protected processListItemReportHistory(response: AxiosResponse): Promise<ListItemReportHistoryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListItemReportHistoryResult.fromJS(resultData200);
            return Promise.resolve<ListItemReportHistoryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemReportHistoryResult>(null as any);
    }

    /**
     * @param model (optional) 
     * @param paginationToken (optional) 
     * @param limit (optional) 
     * @param fullReport (optional) 
     * @return Success
     */
    listReportHistory(model?: string | undefined, paginationToken?: string | undefined, limit?: number | undefined, fullReport?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<ListReportHistoryResult> {
        let url_ = this.baseUrl + "/api/v2/report?";
        if (model === null)
            throw new Error("The parameter 'model' cannot be null.");
        else if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (paginationToken === null)
            throw new Error("The parameter 'paginationToken' cannot be null.");
        else if (paginationToken !== undefined)
            url_ += "paginationToken=" + encodeURIComponent("" + paginationToken) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (fullReport === null)
            throw new Error("The parameter 'fullReport' cannot be null.");
        else if (fullReport !== undefined)
            url_ += "fullReport=" + encodeURIComponent("" + fullReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportHistory(_response);
        });
    }

    protected processListReportHistory(response: AxiosResponse): Promise<ListReportHistoryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListReportHistoryResult.fromJS(resultData200);
            return Promise.resolve<ListReportHistoryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListReportHistoryResult>(null as any);
    }
}

export class BatchDeleteError implements IBatchDeleteError {
    id?: string | undefined;
    error?: string | undefined;

    constructor(data?: IBatchDeleteError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): BatchDeleteError {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDeleteError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["error"] = this.error;
        return data;
    }
}

export interface IBatchDeleteError {
    id?: string | undefined;
    error?: string | undefined;
}

export class BatchDeleteResponse implements IBatchDeleteResponse {
    failedIds?: BatchDeleteError[] | undefined;
    successfulIds?: string[] | undefined;

    constructor(data?: IBatchDeleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["failedIds"])) {
                this.failedIds = [] as any;
                for (let item of _data["failedIds"])
                    this.failedIds!.push(BatchDeleteError.fromJS(item));
            }
            if (Array.isArray(_data["successfulIds"])) {
                this.successfulIds = [] as any;
                for (let item of _data["successfulIds"])
                    this.successfulIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BatchDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.failedIds)) {
            data["failedIds"] = [];
            for (let item of this.failedIds)
                data["failedIds"].push(item.toJSON());
        }
        if (Array.isArray(this.successfulIds)) {
            data["successfulIds"] = [];
            for (let item of this.successfulIds)
                data["successfulIds"].push(item);
        }
        return data;
    }
}

export interface IBatchDeleteResponse {
    failedIds?: BatchDeleteError[] | undefined;
    successfulIds?: string[] | undefined;
}

export class EmailPreferences implements IEmailPreferences {
    emailOnCompletion?: boolean;
    attachExportFiles?: boolean;

    constructor(data?: IEmailPreferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOnCompletion = _data["emailOnCompletion"];
            this.attachExportFiles = _data["attachExportFiles"];
        }
    }

    static fromJS(data: any): EmailPreferences {
        data = typeof data === 'object' ? data : {};
        let result = new EmailPreferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOnCompletion"] = this.emailOnCompletion;
        data["attachExportFiles"] = this.attachExportFiles;
        return data;
    }
}

export interface IEmailPreferences {
    emailOnCompletion?: boolean;
    attachExportFiles?: boolean;
}

export enum ExportReportLocationType {
    None = "None",
    ModelDirectory = "ModelDirectory",
    ModelSubdirectory = "ModelSubdirectory",
    OtherDirectory = "OtherDirectory",
}

export class ExportReportOptions implements IExportReportOptions {
    locationType?: ExportReportLocationType;
    destinationNamingType?: FileDestinationNamingType;
    locationProjectId?: string | undefined;
    locationDirectoryId?: string | undefined;
    emailPreferences?: EmailPreferences | undefined;
    customFileSuffix?: string | undefined;
    readonly hasExportDestination?: boolean;
    exportFormats?: string[] | undefined;
    force?: boolean;

    constructor(data?: IExportReportOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationType = _data["locationType"];
            this.destinationNamingType = _data["destinationNamingType"];
            this.locationProjectId = _data["locationProjectId"];
            this.locationDirectoryId = _data["locationDirectoryId"];
            this.emailPreferences = _data["emailPreferences"] ? EmailPreferences.fromJS(_data["emailPreferences"]) : <any>undefined;
            this.customFileSuffix = _data["customFileSuffix"];
            (<any>this).hasExportDestination = _data["hasExportDestination"];
            if (Array.isArray(_data["exportFormats"])) {
                this.exportFormats = [] as any;
                for (let item of _data["exportFormats"])
                    this.exportFormats!.push(item);
            }
            this.force = _data["force"];
        }
    }

    static fromJS(data: any): ExportReportOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReportOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationType"] = this.locationType;
        data["destinationNamingType"] = this.destinationNamingType;
        data["locationProjectId"] = this.locationProjectId;
        data["locationDirectoryId"] = this.locationDirectoryId;
        data["emailPreferences"] = this.emailPreferences ? this.emailPreferences.toJSON() : <any>undefined;
        data["customFileSuffix"] = this.customFileSuffix;
        data["hasExportDestination"] = this.hasExportDestination;
        if (Array.isArray(this.exportFormats)) {
            data["exportFormats"] = [];
            for (let item of this.exportFormats)
                data["exportFormats"].push(item);
        }
        data["force"] = this.force;
        return data;
    }
}

export interface IExportReportOptions {
    locationType?: ExportReportLocationType;
    destinationNamingType?: FileDestinationNamingType;
    locationProjectId?: string | undefined;
    locationDirectoryId?: string | undefined;
    emailPreferences?: EmailPreferences | undefined;
    customFileSuffix?: string | undefined;
    hasExportDestination?: boolean;
    exportFormats?: string[] | undefined;
    force?: boolean;
}

export class ExportReportRequest implements IExportReportRequest {
    reportId?: string | undefined;
    options?: ExportReportOptions | undefined;
    jobRunId?: string | undefined;

    constructor(data?: IExportReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.options = _data["options"] ? ExportReportOptions.fromJS(_data["options"]) : <any>undefined;
            this.jobRunId = _data["jobRunId"];
        }
    }

    static fromJS(data: any): ExportReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["jobRunId"] = this.jobRunId;
        return data;
    }
}

export interface IExportReportRequest {
    reportId?: string | undefined;
    options?: ExportReportOptions | undefined;
    jobRunId?: string | undefined;
}

export class ExportResultDto implements IExportResultDto {
    reportId?: string | undefined;
    statusId?: string | undefined;
    isReady?: boolean;
    exports?: { [key: string]: ExportResultFormatDto; } | undefined;

    constructor(data?: IExportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.statusId = _data["statusId"];
            this.isReady = _data["isReady"];
            if (_data["exports"]) {
                this.exports = {} as any;
                for (let key in _data["exports"]) {
                    if (_data["exports"].hasOwnProperty(key))
                        (<any>this.exports)![key] = _data["exports"][key] ? ExportResultFormatDto.fromJS(_data["exports"][key]) : new ExportResultFormatDto();
                }
            }
        }
    }

    static fromJS(data: any): ExportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["statusId"] = this.statusId;
        data["isReady"] = this.isReady;
        if (this.exports) {
            data["exports"] = {};
            for (let key in this.exports) {
                if (this.exports.hasOwnProperty(key))
                    (<any>data["exports"])[key] = this.exports[key] ? this.exports[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IExportResultDto {
    reportId?: string | undefined;
    statusId?: string | undefined;
    isReady?: boolean;
    exports?: { [key: string]: ExportResultFormatDto; } | undefined;
}

export class ExportResultFormatDto implements IExportResultFormatDto {
    format?: string | undefined;
    failureMessage?: string | undefined;
    fileName?: string | undefined;
    exportUri?: string | undefined;
    bim360ProjectId?: string | undefined;
    bim360ItemId?: string | undefined;
    exportS3Key?: string | undefined;

    constructor(data?: IExportResultFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
            this.failureMessage = _data["failureMessage"];
            this.fileName = _data["fileName"];
            this.exportUri = _data["exportUri"];
            this.bim360ProjectId = _data["bim360ProjectId"];
            this.bim360ItemId = _data["bim360ItemId"];
            this.exportS3Key = _data["exportS3Key"];
        }
    }

    static fromJS(data: any): ExportResultFormatDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportResultFormatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        data["failureMessage"] = this.failureMessage;
        data["fileName"] = this.fileName;
        data["exportUri"] = this.exportUri;
        data["bim360ProjectId"] = this.bim360ProjectId;
        data["bim360ItemId"] = this.bim360ItemId;
        data["exportS3Key"] = this.exportS3Key;
        return data;
    }
}

export interface IExportResultFormatDto {
    format?: string | undefined;
    failureMessage?: string | undefined;
    fileName?: string | undefined;
    exportUri?: string | undefined;
    bim360ProjectId?: string | undefined;
    bim360ItemId?: string | undefined;
    exportS3Key?: string | undefined;
}

export enum FileDestinationNamingType {
    None = "None",
    Overwrite = "Overwrite",
    AppendTimestamp = "AppendTimestamp",
}

export class FileDto implements IFileDto {
    id?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.hubId = _data["hubId"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["hubId"] = this.hubId;
        return data;
    }
}

export interface IFileDto {
    id?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;
}

export class FileType implements IFileType {
    readonly displayText?: string | undefined;
    readonly fileDescription?: string | undefined;
    fileExtension?: string | undefined;

    constructor(data?: IFileType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).displayText = _data["displayText"];
            (<any>this).fileDescription = _data["fileDescription"];
            this.fileExtension = _data["fileExtension"];
        }
    }

    static fromJS(data: any): FileType {
        data = typeof data === 'object' ? data : {};
        let result = new FileType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayText"] = this.displayText;
        data["fileDescription"] = this.fileDescription;
        data["fileExtension"] = this.fileExtension;
        return data;
    }
}

export interface IFileType {
    displayText?: string | undefined;
    fileDescription?: string | undefined;
    fileExtension?: string | undefined;
}

export enum HubType {
    Unknown = "Unknown",
    A360 = "A360",
    B360Team = "B360Team",
    B360 = "B360",
    Deleted = "Deleted",
}

export class JobFile implements IJobFile {
    readonly id?: string | undefined;
    readonly name?: string | undefined;
    readonly displayName?: string | undefined;
    readonly parentId?: string | undefined;
    readonly projectId?: string | undefined;
    readonly lastUpdated?: Date;
    readonly lastUpdatedBy?: string | undefined;
    readonly isHidden?: boolean;
    directoryId?: string | undefined;
    fileType?: FileType | undefined;
    thumbnail?: string | undefined;
    readonly isDirectory?: boolean;
    versionNumber?: number;
    objectId?: string | undefined;
    isComposite?: boolean;
    size?: number;
    isLocked?: boolean;
    pathInProject?: string | undefined;
    derivativesId?: string | undefined;
    isProcessed?: boolean;
    compositeParentFile?: string | undefined;
    readonly fileNameWithExtension?: string | undefined;
    hubId?: string | undefined;
    hubName?: string | undefined;
    region?: string | undefined;
    hubType?: HubType;
    projectName?: string | undefined;
    parentName?: string | undefined;
    projectType?: ProjectType;

    constructor(data?: IJobFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).parentId = _data["parentId"];
            (<any>this).projectId = _data["projectId"];
            (<any>this).lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            (<any>this).lastUpdatedBy = _data["lastUpdatedBy"];
            (<any>this).isHidden = _data["isHidden"];
            this.directoryId = _data["directoryId"];
            this.fileType = _data["fileType"] ? FileType.fromJS(_data["fileType"]) : <any>undefined;
            this.thumbnail = _data["thumbnail"];
            (<any>this).isDirectory = _data["isDirectory"];
            this.versionNumber = _data["versionNumber"];
            this.objectId = _data["objectId"];
            this.isComposite = _data["isComposite"];
            this.size = _data["size"];
            this.isLocked = _data["isLocked"];
            this.pathInProject = _data["pathInProject"];
            this.derivativesId = _data["derivativesId"];
            this.isProcessed = _data["isProcessed"];
            this.compositeParentFile = _data["compositeParentFile"];
            (<any>this).fileNameWithExtension = _data["fileNameWithExtension"];
            this.hubId = _data["hubId"];
            this.hubName = _data["hubName"];
            this.region = _data["region"];
            this.hubType = _data["hubType"];
            this.projectName = _data["projectName"];
            this.parentName = _data["parentName"];
            this.projectType = _data["projectType"];
        }
    }

    static fromJS(data: any): JobFile {
        data = typeof data === 'object' ? data : {};
        let result = new JobFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["projectId"] = this.projectId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["isHidden"] = this.isHidden;
        data["directoryId"] = this.directoryId;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : <any>undefined;
        data["thumbnail"] = this.thumbnail;
        data["isDirectory"] = this.isDirectory;
        data["versionNumber"] = this.versionNumber;
        data["objectId"] = this.objectId;
        data["isComposite"] = this.isComposite;
        data["size"] = this.size;
        data["isLocked"] = this.isLocked;
        data["pathInProject"] = this.pathInProject;
        data["derivativesId"] = this.derivativesId;
        data["isProcessed"] = this.isProcessed;
        data["compositeParentFile"] = this.compositeParentFile;
        data["fileNameWithExtension"] = this.fileNameWithExtension;
        data["hubId"] = this.hubId;
        data["hubName"] = this.hubName;
        data["region"] = this.region;
        data["hubType"] = this.hubType;
        data["projectName"] = this.projectName;
        data["parentName"] = this.parentName;
        data["projectType"] = this.projectType;
        return data;
    }
}

export interface IJobFile {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    parentId?: string | undefined;
    projectId?: string | undefined;
    lastUpdated?: Date;
    lastUpdatedBy?: string | undefined;
    isHidden?: boolean;
    directoryId?: string | undefined;
    fileType?: FileType | undefined;
    thumbnail?: string | undefined;
    isDirectory?: boolean;
    versionNumber?: number;
    objectId?: string | undefined;
    isComposite?: boolean;
    size?: number;
    isLocked?: boolean;
    pathInProject?: string | undefined;
    derivativesId?: string | undefined;
    isProcessed?: boolean;
    compositeParentFile?: string | undefined;
    fileNameWithExtension?: string | undefined;
    hubId?: string | undefined;
    hubName?: string | undefined;
    region?: string | undefined;
    hubType?: HubType;
    projectName?: string | undefined;
    parentName?: string | undefined;
    projectType?: ProjectType;
}

export enum JobRunItemStatusType {
    Pending = "Pending",
    InProgress = "InProgress",
    Cancelled = "Cancelled",
    FailedLimitDataSize = "FailedLimitDataSize",
    FailedLimitProcessingTime = "FailedLimitProcessingTime",
    FailedDownload = "FailedDownload",
    FailedInstructions = "FailedInstructions",
    FailedUpload = "FailedUpload",
    FailedUploadOptional = "FailedUploadOptional",
    Success = "Success",
    Error = "Error",
}

export enum JobRunStatusType {
    Cancelled = "Cancelled",
    Scheduled = "Scheduled",
    Queued = "Queued",
    InProgress = "InProgress",
    PostProcessing = "PostProcessing",
    Success = "Success",
    Error = "Error",
    PartiallyCompleted = "PartiallyCompleted",
}

export class ListItemReportHistoryResult implements IListItemReportHistoryResult {
    paginationData?: PaginationData | undefined;
    items?: TestItemReportSummaryDto[] | undefined;
    isDone?: boolean;

    constructor(data?: IListItemReportHistoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TestItemReportSummaryDto.fromJS(item));
            }
            this.isDone = _data["isDone"];
        }
    }

    static fromJS(data: any): ListItemReportHistoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemReportHistoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isDone"] = this.isDone;
        return data;
    }
}

export interface IListItemReportHistoryResult {
    paginationData?: PaginationData | undefined;
    items?: TestItemReportSummaryDto[] | undefined;
    isDone?: boolean;
}

export class ListReportHistoryResult implements IListReportHistoryResult {
    paginationData?: PaginationData | undefined;
    items?: TestReportSummaryDto[] | undefined;
    isDone?: boolean;

    constructor(data?: IListReportHistoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TestReportSummaryDto.fromJS(item));
            }
            this.isDone = _data["isDone"];
        }
    }

    static fromJS(data: any): ListReportHistoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListReportHistoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isDone"] = this.isDone;
        return data;
    }
}

export interface IListReportHistoryResult {
    paginationData?: PaginationData | undefined;
    items?: TestReportSummaryDto[] | undefined;
    isDone?: boolean;
}

export class PaginationData implements IPaginationData {
    paginationToken?: string | undefined;
    limit?: number;

    constructor(data?: IPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginationToken = _data["paginationToken"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): PaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginationToken"] = this.paginationToken;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IPaginationData {
    paginationToken?: string | undefined;
    limit?: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export enum ProjectType {
    Unknown = "Unknown",
    A360 = "A360",
    B360Team = "B360Team",
    B360Docs = "B360Docs",
    ACC = "ACC",
    Deleted = "Deleted",
}

export class ReportSummaryDto implements IReportSummaryDto {
    reportId?: string | undefined;
    totalFiles?: number;
    successFiles?: number;
    failedFiles?: number;
    pendingFiles?: number;
    startTime?: Date;
    endTime?: Date;
    jobName?: string | undefined;
    jobId?: string | undefined;
    jobRunId?: string | undefined;
    status?: JobRunStatusType;
    userId?: string | undefined;
    email?: string | undefined;
    customerId?: string | undefined;
    files?: FileDto[] | undefined;

    constructor(data?: IReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.totalFiles = _data["totalFiles"];
            this.successFiles = _data["successFiles"];
            this.failedFiles = _data["failedFiles"];
            this.pendingFiles = _data["pendingFiles"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.jobName = _data["jobName"];
            this.jobId = _data["jobId"];
            this.jobRunId = _data["jobRunId"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["totalFiles"] = this.totalFiles;
        data["successFiles"] = this.successFiles;
        data["failedFiles"] = this.failedFiles;
        data["pendingFiles"] = this.pendingFiles;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["jobName"] = this.jobName;
        data["jobId"] = this.jobId;
        data["jobRunId"] = this.jobRunId;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportSummaryDto {
    reportId?: string | undefined;
    totalFiles?: number;
    successFiles?: number;
    failedFiles?: number;
    pendingFiles?: number;
    startTime?: Date;
    endTime?: Date;
    jobName?: string | undefined;
    jobId?: string | undefined;
    jobRunId?: string | undefined;
    status?: JobRunStatusType;
    userId?: string | undefined;
    email?: string | undefined;
    customerId?: string | undefined;
    files?: FileDto[] | undefined;
}

export class TestItemReportSummaryDto implements ITestItemReportSummaryDto {
    jobRunItemId?: string | undefined;
    status?: JobRunItemStatusType;
    file?: FileDto | undefined;
    readonly summary?: ReportSummaryDto | undefined;
    testSummary?: TestReportSummaryDto | undefined;
    testItemString?: string | undefined;

    constructor(data?: ITestItemReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobRunItemId = _data["jobRunItemId"];
            this.status = _data["status"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            (<any>this).summary = _data["summary"] ? ReportSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            this.testSummary = _data["testSummary"] ? TestReportSummaryDto.fromJS(_data["testSummary"]) : <any>undefined;
            this.testItemString = _data["testItemString"];
        }
    }

    static fromJS(data: any): TestItemReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestItemReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobRunItemId"] = this.jobRunItemId;
        data["status"] = this.status;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["testSummary"] = this.testSummary ? this.testSummary.toJSON() : <any>undefined;
        data["testItemString"] = this.testItemString;
        return data;
    }
}

export interface ITestItemReportSummaryDto {
    jobRunItemId?: string | undefined;
    status?: JobRunItemStatusType;
    file?: FileDto | undefined;
    summary?: ReportSummaryDto | undefined;
    testSummary?: TestReportSummaryDto | undefined;
    testItemString?: string | undefined;
}

export class TestReportDto implements ITestReportDto {
    reportId?: string | undefined;
    totalFiles?: number;
    successFiles?: number;
    failedFiles?: number;
    pendingFiles?: number;
    startTime?: Date;
    endTime?: Date;
    jobName?: string | undefined;
    jobId?: string | undefined;
    jobRunId?: string | undefined;
    status?: JobRunStatusType;
    userId?: string | undefined;
    email?: string | undefined;
    customerId?: string | undefined;
    files?: FileDto[] | undefined;
    testString?: string | undefined;
    jobFiles?: JobFile[] | undefined;
    testReportItems?: string[] | undefined;

    constructor(data?: ITestReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.totalFiles = _data["totalFiles"];
            this.successFiles = _data["successFiles"];
            this.failedFiles = _data["failedFiles"];
            this.pendingFiles = _data["pendingFiles"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.jobName = _data["jobName"];
            this.jobId = _data["jobId"];
            this.jobRunId = _data["jobRunId"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
            this.testString = _data["testString"];
            if (Array.isArray(_data["jobFiles"])) {
                this.jobFiles = [] as any;
                for (let item of _data["jobFiles"])
                    this.jobFiles!.push(JobFile.fromJS(item));
            }
            if (Array.isArray(_data["testReportItems"])) {
                this.testReportItems = [] as any;
                for (let item of _data["testReportItems"])
                    this.testReportItems!.push(item);
            }
        }
    }

    static fromJS(data: any): TestReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["totalFiles"] = this.totalFiles;
        data["successFiles"] = this.successFiles;
        data["failedFiles"] = this.failedFiles;
        data["pendingFiles"] = this.pendingFiles;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["jobName"] = this.jobName;
        data["jobId"] = this.jobId;
        data["jobRunId"] = this.jobRunId;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["testString"] = this.testString;
        if (Array.isArray(this.jobFiles)) {
            data["jobFiles"] = [];
            for (let item of this.jobFiles)
                data["jobFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.testReportItems)) {
            data["testReportItems"] = [];
            for (let item of this.testReportItems)
                data["testReportItems"].push(item);
        }
        return data;
    }
}

export interface ITestReportDto {
    reportId?: string | undefined;
    totalFiles?: number;
    successFiles?: number;
    failedFiles?: number;
    pendingFiles?: number;
    startTime?: Date;
    endTime?: Date;
    jobName?: string | undefined;
    jobId?: string | undefined;
    jobRunId?: string | undefined;
    status?: JobRunStatusType;
    userId?: string | undefined;
    email?: string | undefined;
    customerId?: string | undefined;
    files?: FileDto[] | undefined;
    testString?: string | undefined;
    jobFiles?: JobFile[] | undefined;
    testReportItems?: string[] | undefined;
}

export class TestReportSummaryDto implements ITestReportSummaryDto {
    reportId?: string | undefined;
    totalFiles?: number;
    successFiles?: number;
    failedFiles?: number;
    pendingFiles?: number;
    startTime?: Date;
    endTime?: Date;
    jobName?: string | undefined;
    jobId?: string | undefined;
    jobRunId?: string | undefined;
    status?: JobRunStatusType;
    userId?: string | undefined;
    email?: string | undefined;
    customerId?: string | undefined;
    files?: FileDto[] | undefined;
    testString?: string | undefined;

    constructor(data?: ITestReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.totalFiles = _data["totalFiles"];
            this.successFiles = _data["successFiles"];
            this.failedFiles = _data["failedFiles"];
            this.pendingFiles = _data["pendingFiles"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.jobName = _data["jobName"];
            this.jobId = _data["jobId"];
            this.jobRunId = _data["jobRunId"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
            this.testString = _data["testString"];
        }
    }

    static fromJS(data: any): TestReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["totalFiles"] = this.totalFiles;
        data["successFiles"] = this.successFiles;
        data["failedFiles"] = this.failedFiles;
        data["pendingFiles"] = this.pendingFiles;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["jobName"] = this.jobName;
        data["jobId"] = this.jobId;
        data["jobRunId"] = this.jobRunId;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["testString"] = this.testString;
        return data;
    }
}

export interface ITestReportSummaryDto {
    reportId?: string | undefined;
    totalFiles?: number;
    successFiles?: number;
    failedFiles?: number;
    pendingFiles?: number;
    startTime?: Date;
    endTime?: Date;
    jobName?: string | undefined;
    jobId?: string | undefined;
    jobRunId?: string | undefined;
    status?: JobRunStatusType;
    userId?: string | undefined;
    email?: string | undefined;
    customerId?: string | undefined;
    files?: FileDto[] | undefined;
    testString?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}